// The width from which on the layout is the desktop one, Bootstrap's lg breakpoint: the sidebar can collapse,
// and the dashboards dock their panel beside the timetable instead of covering it.
export const DESKTOP = '(min-width: 992px)'

export function isDesktop() {
  return window.matchMedia ? window.matchMedia(DESKTOP).matches : true
}

// Calls back with whether it is the desktop layout whenever that changes. Returns what stops it.
export function onDesktopChange(callback) {
  if (!window.matchMedia) return () => {}

  const query = window.matchMedia(DESKTOP)
  const listener = () => callback(query.matches)
  query.addEventListener('change', listener)
  return () => query.removeEventListener('change', listener)
}
